import { Injectable } from '@angular/core';
import { Election } from 'src/app/models/Election';
import { Reaction } from 'src/app/models/Reaction';
import { AlertService } from 'src/app/util/alert.service';
import { ToastService } from 'src/app/util/toast.service';

import { AuthService } from '../auth.service';
import { BackEndService } from '../backEnd.service';
import { WhatsappService } from '../whatsapp.service';
import { CommitteeService } from './committee.service';
import { ElectionMember } from 'src/app/models/ElectionMember';
import { CommitteeMember } from 'src/app/models/CommitteeMember';

@Injectable({
  providedIn: 'root',
})
export class ElectionService {
  electionStatusList: string[] = ["Draft", , "Publish", "End", "Delete"];
  electionList: Election[];
  election: Election = new Election;
  candidateList: ElectionMember[] = [];
  myVote: ElectionMember;

  constructor(private backEnd: BackEndService,
    private auth: AuthService, private toast: ToastService, private whatsApp: WhatsappService,
    private alert: AlertService, private cs: CommitteeService) {
    this.auth.getLoggedInEmployee();
  }
  getElection(id, variable?: string) {
    variable = variable ?? "id";
    return new Promise((resolve) => {
      this.backEnd.getSingle("election", [[variable, id]]).then((election: Election) => {
        this.jsonParsing(election);
        this.election = election;
        resolve(election);
      })
    })
  }

  jsonParsing(election: Election) {
    if (election.creator && ((typeof election.creator === 'string'))) {
      election.creator = JSON.parse(election.creator)
    }
    if (election.member_rule && ((typeof election.member_rule === 'string'))) {
      election.member_rule = JSON.parse(election.member_rule)
    }
    if (election.candidate_rule && ((typeof election.candidate_rule === 'string'))) {
      election.candidate_rule = JSON.parse(election.candidate_rule)
    }
    if (election.election_rule && ((typeof election.election_rule === 'string'))) {
      election.election_rule = JSON.parse(election.election_rule)
    }
    election.candidate_final_date = new Date(election.candidate_final_date);
    election.election_start_date = new Date(election.election_start_date);
    election.election_end_date = new Date(election.election_end_date);

  }


  getAllElection() {
    return new Promise((resolve) => {
      let query = [["business_id", this.auth.loggedInEmployee.business_id]]
      if (!this.auth.loggedInEmployee.assigned_area || ((this.auth.loggedInEmployee.assigned_area + '').length < 3)) {
        // query.push(["status", "Publish"])
        query.push(["status.eq.Publish,created_by.eq." + this.auth.loggedInEmployee.id, "", "or"])
      }
      query.push(["committee_id", this.cs.committee.id]);
      this.backEnd.searchObject("election", query).then((electionList: Election[]) => {
        this.electionList = electionList;
        for (let election of this.electionList) {
          this.jsonParsing(election);
        }
        resolve(true);
      })
    })
  }


  saveObject(election?: Election) {
    return new Promise((resolve) => {
      if (!election) {
        election = this.election;
      }
      if (!election.id) {
        election.created_by = this.auth.loggedInEmployee.id;
        election.business_id = this.auth.loggedInEmployee.business_id;
      }
      election.committee_id = this.cs.committee.id;
      let obj = { ...election };
      this.backEnd.saveObject("election", obj).then((response) => {
        if (response) {
          this.toast.success("Election Saved");
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }


  joinAsCandidate() {
    return new Promise((resolve) => {
      let newEm: ElectionMember = new ElectionMember();
      newEm.election_id = this.election.id;
      newEm.member_id = this.cs.myMemberShip.id;
      newEm.business_id = this.auth.loggedInEmployee.business_id;
      newEm.status = "Pending";
      newEm.role = "Candidate";
      newEm.created_by = JSON.stringify(this.auth.loggedInEmployee);
      this.backEnd.saveObject("election_member", newEm).then((response) => {
        newEm.created_by = JSON.parse(newEm.created_by);
        if (response) {
          this.toast.success("You have successfully applied as Candidate");
          this.candidateList.push(newEm);
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  setStatus(candidate: ElectionMember, status: string) {
    candidate.status = status;
    this.backEnd.saveObject("election_member", candidate).then((response) => {
      if (response) {
        this.toast.success("Candidate Approved");
      } else {
        this.toast.error("Failed to approve candidate");
      }

    });
  }

  getAllCandidate() {
    return new Promise((resolve) => {
      let query = [["election_id", this.election.id], ["role", "Candidate"]];
      this.backEnd.searchObject("election_member", query).then((candidateList: ElectionMember[]) => {
        for (let candidate of candidateList) {
          if (candidate.created_by && ((typeof candidate.created_by === 'string'))) {
            candidate.created_by = JSON.parse(candidate.created_by)
          }
        }
        this.candidateList = candidateList;
        resolve(candidateList);
      });
    });
  }


  vote(candidate_id: string, member_id: string) {
    return new Promise((resolve) => {
      let newEm: ElectionMember = new ElectionMember();
      newEm.election_id = this.election.id;
      newEm.member_id = member_id;
      newEm.business_id = this.auth.loggedInEmployee.business_id;
      newEm.status = "Voted";
      newEm.role = "Voter";
      newEm.vote_date = new Date();
      newEm.vote_to = candidate_id;
      this.backEnd.saveObject("election_member", newEm).then((response) => {
        if (response) {
          this.toast.success("You have successfully voted");
          this.myVote = newEm;
          resolve(true);
        } else {
          resolve(false);
        }
      });
    });
  }

  getMyVote() {
    return new Promise((resolve) => {
      let query = [["election_id", this.election.id], ["member_id", this.cs.myMemberShip.id], ["role", "Voter"]];
      this.backEnd.searchObject("election_member", query).then((emList: ElectionMember[]) => {
        if (emList && emList.length == 1) {
          let em = emList[0];
          if (em.created_by && ((typeof em.created_by === 'string'))) {
            em.created_by = JSON.parse(em.created_by)
          }
          this.myVote = em;
          resolve(em);
        } else {
          resolve(null);
        }
      });
    });
  }

  calculateResult() {
    return new Promise((resolve) => {
      this.backEnd.rpcFunction('get_vote_counts', { election_id_input: this.election.id }).then((result) => {

        console.log(result);
        if (result.body && result.body.data.length > 0) {
          let description = "<ul>";
          let blankCount = 0;
          for (let abc of result.body.data) {
            let candidate: CommitteeMember = this.cs.memberList.find(x => x.id == abc.candidate_id);
            if (candidate) {
              description += "<li><b>" + abc.total_votes + "</b> = " + candidate.profile_meta?.name + "(" + candidate.profile_meta.origin_city + ")</li>";
            } else {
              blankCount = abc.total_votes;
            }
          }
          description += "<li><b>" + blankCount + "</b> = Blank</li>";

          description += "</ul>";
          this.alert.showAlert("Result", description, "Freeze").then((value) => {
          });
        }
      })
      // this.supa.countObject(this.election.id).then((result) => {
      //   resolve(result);
      // });
    });
  }
}
